import React, { ReactNode } from 'react'

import Box from 'components_new/atoms/Box'

import { BOARD } from './accents'

/**
 * Small uppercase section caption inside a node body (e.g. "GRUPPERA PÅ").
 */
const Caption = (props: { children: ReactNode }) => (
  <Box
    sx={{
      color: BOARD.textFaint,
      fontFamily: BOARD.fontBody,
      fontSize: '10px',
      fontWeight: 700,
      letterSpacing: '0.07em',
      mb: 0.5,
      textTransform: 'uppercase'
    }}
  >
    {props.children}
  </Box>
)

export default Caption
